var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "渲染颜色" } },
        [
          _c(
            "el-radio-group",
            {
              attrs: { size: "small" },
              model: {
                value: _vm.whereColor,
                callback: function($$v) {
                  _vm.whereColor = $$v
                },
                expression: "whereColor"
              }
            },
            [
              _vm._l(_vm.renderColorConfigList, function(item, index) {
                return _c(
                  "el-radio-button",
                  { key: index, attrs: { label: item.label } },
                  [_vm._v("\n                       " + _vm._s(item.value))]
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c("el-color-picker", {
                    model: {
                      value: _vm.renderColor,
                      callback: function($$v) {
                        _vm.renderColor = $$v
                      },
                      expression: "renderColor"
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5feb1134", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5feb1134","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/render_setting/RenderColor.vue
// module id = null
// module chunks = 